"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var util_1 = require("./util");

var DefaultPageElementRenderer_1 = require("./renderers/DefaultPageElementRenderer");

var DarkSectionsRenderer_1 = require("./renderers/DarkSectionsRenderer");

var LightSectionsRenderer_1 = require("./renderers/LightSectionsRenderer");
/**
 * Determines by its typename if a content element needs to be wrapped
 * by an LSG Theme component.
 *
 * NOTE(benjamin):
 * This is currently based on a fixed list of content types. We might need
 * to find a flexible solution for making this extensible for any consuming
 * project in the future.
 */


function shouldContentElementBeWrappedInTheme(elm) {
  return elm.type() === 'ContentfulSection';
}

exports.shouldContentElementBeWrappedInTheme = shouldContentElementBeWrappedInTheme;
var ContentElementWrapperTheme;

(function (ContentElementWrapperTheme) {
  ContentElementWrapperTheme[ContentElementWrapperTheme["Dark"] = 0] = "Dark";
  ContentElementWrapperTheme[ContentElementWrapperTheme["Light"] = 1] = "Light";
})(ContentElementWrapperTheme = exports.ContentElementWrapperTheme || (exports.ContentElementWrapperTheme = {}));

function inferContentElementThemeWrapperOrType(contentElement) {
  var shouldBeWrappedInTheme = shouldContentElementBeWrappedInTheme(contentElement);
  return shouldBeWrappedInTheme ? contentElement["boolean"]('darkTheme', false) ? ContentElementWrapperTheme.Dark : ContentElementWrapperTheme.Light : contentElement.type();
}

exports.inferContentElementThemeWrapperOrType = inferContentElementThemeWrapperOrType;
exports.wrapperThemeSectionRendererMap = (_a = {}, _a[ContentElementWrapperTheme.Dark] = DarkSectionsRenderer_1.DarkSectionsRenderer, _a[ContentElementWrapperTheme.Light] = LightSectionsRenderer_1.LightSectionsRenderer, _a);

function assembleRenderersFrom(content, componentMap) {
  var groupedElements = util_1.splitContentElementsByDescriptor(content, inferContentElementThemeWrapperOrType);
  return groupedElements.map(function (contentElements) {
    var _a = __read(contentElements, 1),
        contentElement = _a[0];

    var theme = inferContentElementThemeWrapperOrType(contentElement);
    return {
      renderer: exports.wrapperThemeSectionRendererMap[theme] || DefaultPageElementRenderer_1.DefaultPageElementRenderer,
      component: componentMap[contentElement.type()],
      rendererProps: {},
      data: contentElements
    };
  });
}

exports.assembleRenderersFrom = assembleRenderersFrom;

exports.PageContentList = function (_a) {
  var content = _a.content,
      componentMap = _a.componentMap;
  return assembleRenderersFrom(content, componentMap).map(function (renderer, index) {
    var Renderer = renderer.renderer;
    return react_1["default"].createElement(Renderer, {
      key: "PageContentList-" + index,
      data: renderer.data,
      component: renderer.component,
      props: renderer.rendererProps
    });
  });
};